import { render, staticRenderFns } from "./PackageIntake.vue?vue&type=template&id=3a48c14c&scoped=true&"
import script from "./PackageIntake.vue?vue&type=script&lang=js&"
export * from "./PackageIntake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48c14c",
  null
  
)

export default component.exports